export default {
  namespaced: true,
  state () {
    return {
      isMenuCollapse: localStorage.getItem('isCollapseMenu') === 'true',
      isMuteNotification: localStorage.getItem('isMuteNotification'),
      isMobileMenuOpen: false
    }
  },
  mutations: {
    setIsMenuCollapse(state, payload) {
      state.isMenuCollapse = payload
    },
    setIsMuteNotification(state, payload) {
      state.isMuteNotification = payload
    },
    setIsMobileMenuOpen(state, payload) {
      state.isMobileMenuOpen = payload
    },
  },
  actions: {
    getIsMenuCollapse({commit}, payload){
      localStorage.setItem('isCollapseMenu', payload);
      commit('setIsMenuCollapse', payload)
    },
    getIsMuteNotification({commit}, payload){
      localStorage.setItem('isMuteNotification', payload);
      commit('setIsMuteNotification', payload)
    },
    toggleMobileMenu({ commit, state }) {
      commit('setIsMobileMenuOpen', !state.isMobileMenuOpen)
    },
    closeMobileMenu({ commit }) {
      commit('setIsMobileMenuOpen', false)
    },
  },
  getters: {
    isMenuCollapse: (state) => state.isMenuCollapse,
    isMuteNotification: (state) => state.isMuteNotification,
    isMobileMenuOpen: (state) => state.isMobileMenuOpen,
  }
}